import {
  Container,
  Typography,
  Box,
  Grid,
  useMediaQuery,
  useTheme,
  Dialog,
  FormControlLabel,
  Checkbox,
  Stack,
} from "@mui/material";
import Add from "@mui/icons-material/Add";
import { useState, useEffect } from "react";
import PickAddress from "../address/pick-address";
import { useAppDispatch, useAppSelector } from "../../store/appHooks";
import {
  addAddress,
  deleteAddress,
  editAddress,
  getAddress,
  makeDefaultAddress,
} from "../../slices/addressReducer";

import LocationOn from "@mui/icons-material/LocationOn";
import { ADDRESS_TYPE } from "../../constants/general";
import { handleSnackBar } from "../../slices/global";
import styled from "@emotion/styled";
import { Button } from "@mui/material";
import AddressForm from "./address-form";
import Header from "components/Header";

export const AddOption = styled(Button)({
  border: "2px dashed #383838",
  height: "100%",
  width: "100%",
  fontSize: 35,
});
const SavedAddress = ({
  onClose = null,
  selectionMode = false,
}: {
  onClose?: any;
  selectionMode?: Boolean;
}) => {
  const theme = useTheme();
  const matchesSm = useMediaQuery(theme.breakpoints.down("sm"));
  const matchesXs = useMediaQuery(theme.breakpoints.only("xs"));
  const [addAddressModal, setaddAddressModal] = useState(false);
  const [editAddressData, setEditAddressData] = useState(null);
  const [addAddressForm, setAddAddressForm] = useState(false);
  const dispatch = useAppDispatch();
  const { addressReducer } = useAppSelector((state) => state);
  const { savedAddress } = addressReducer;

  useEffect(() => {
    dispatch(getAddress());
  }, [dispatch]);

  const createAddress = (editData: any, data: any) => {
    if (editData) {
      dispatch(
        editAddress({
          id: editData?.id,
          callBack: () => {
            setaddAddressModal(false);
            setEditAddressData(null);
            setAddAddressForm(false);
            onClose && onClose();
          },
          data: {
            ...data,
            addressType: ADDRESS_TYPE.DELIVERY,
          },
        })
      );
    } else {
      dispatch(
        addAddress({
          callBack: () => {
            setaddAddressModal(false);
            setAddAddressForm(false);
          },
          data: { ...data, addressType: ADDRESS_TYPE.DELIVERY },
        })
      );
    }
  };

  const deleteAdd = (id: any) => {
    dispatch(deleteAddress({ id }));
  };
  const checkWithLenghtValidation = () => {
    if (savedAddress.length < 5) {
      setaddAddressModal(true);
      return;
    }

    dispatch(
      handleSnackBar({
        open: true,
        message: "Maximum 5 address are allowed.",
        severity: "error",
      })
    );
  };

  if (editAddressData && (matchesSm || matchesXs)) {
    return (
      <Dialog open fullScreen>
        <Header />
        <Box
          sx={{
            display: {
              md: "flex",
              lg: "flex",
              xl: "flex",
              sm: "flex",
              xs: "flex",
            },
            px: "4%",
            py: "20px",
            borderBottom: "1px solid #F4F4F4",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              flex: 2,
            }}
          >
            <img
              src="/assets/img/icons/arrow_left.svg"
              alt=""
              width="24px"
              height="24px"
              onClick={() => setEditAddressData(null)}
            />
            <Typography
              sx={{
                color: "#323232",
                fontWeight: 600,
                fontSize: "24px",
                lineHeight: "35px",
              }}
            >
              Edit Address
            </Typography>
          </Box>
        </Box>
        <AddressForm createAddress={createAddress} editData={editAddressData} />
      </Dialog>
    );
  }

  if (addAddressForm && (matchesSm || matchesXs)) {
    return (
      <Dialog open fullScreen>
        <Header />
        <Box
          sx={{
            display: {
              md: "flex",
              lg: "flex",
              xl: "flex",
              sm: "flex",
              xs: "flex",
            },
            px: "4%",
            py: "20px",
            borderBottom: "1px solid #F4F4F4",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              flex: 2,
            }}
          >
            <img
              src="/assets/img/icons/arrow_left.svg"
              alt=""
              width="24px"
              height="24px"
              onClick={() => setAddAddressForm(false)}
            />
            <Typography
              sx={{
                color: "#323232",
                fontWeight: 600,
                fontSize: "24px",
                lineHeight: "35px",
              }}
            >
              Add New Address
            </Typography>
          </Box>
        </Box>
        <AddressForm createAddress={createAddress} editData={null} />
      </Dialog>
    );
  }
  return (
    <Box>
      <Grid container>
        <Grid
          item
          md={4}
          lg={4}
          xl={4}
          sm={12}
          xs={12}
          sx={{ background: "#F4F4F4" }}
        >
          <Box>
            <Box
              sx={{
                mx: { md: "10%", lg: "10%", xl: "10%", sm: "5%", xs: "5%" },
                my: "20px",
              }}
            >
              <Typography
                sx={{ color: "#323232", fontWeight: 600, fontSize: "20px" }}
              >
                Address
              </Typography>

              {savedAddress.length > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                    my: "15px",
                  }}
                >
                  {savedAddress.map((add: any) => (
                    <Stack>
                      <Box
                        sx={{
                          border: "1px solid #E2E2E2",
                          padding: "20px",
                          background: "#FFF",
                          display: "flex",
                          gap: "10px",
                          borderRadius: "8px",
                          justifyContent: "space-between",
                          ...(add.is_default
                            ? {
                                border: "1px solid #6E8C20",
                                background: "#E1FFA2",
                              }
                            : {}),
                        }}
                      >
                        <div>
                          <Typography
                            sx={{
                              color: "#323232",
                              fontSize: "16px",
                              fontWeight: 400,
                              lineHeight: "22px",
                            }}
                          >
                            {[add.address_line_1, add.address_line_2]
                              .filter((r) => r)
                              .join(", ")}
                          </Typography>
                          <Typography
                            sx={{
                              color: "#323232",
                              fontSize: "16px",
                              fontWeight: 400,
                              lineHeight: "22px",
                            }}
                          >
                            {[add.city, add.state, add.zipcode]
                              .filter((r) => r)
                              .join(", ")}
                          </Typography>
                        </div>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            justifyContent: "space-between",
                            gap: "20px",
                          }}
                        >
                          <Box sx={{ display: "flex", gap: "10px" }}>
                            <img
                              src="/assets/img/icons/edit.svg"
                              alt=""
                              onClick={() => setEditAddressData(add)}
                            />
                            {!add.is_default && add.address_type === 2 && (
                              <img
                                src="/assets/img/icons/trash_error.svg"
                                alt=""
                                onClick={() => deleteAdd(add.id)}
                              />
                            )}
                          </Box>
                          {/* {add.is_default && (
                            <Typography
                              sx={{
                                color: "#A2A2A2",
                                fontWeight: 400,
                                fontSize: "13px",
                              }}
                            >
                              Default
                            </Typography>
                          )} */}
                        </Box>
                      </Box>
                      <FormControlLabel
                        label={
                          add.is_default ? "Default Address" : "Make Default"
                        }
                        control={
                          <Checkbox
                            checked={add.is_default}
                            onChange={({ target }) => {
                              if (!add.is_default)
                                dispatch(
                                  makeDefaultAddress({
                                    id: add.id,
                                    callBack: () => onClose && onClose(),
                                  })
                                );
                            }}
                            sx={{ padding: "0px" }}
                            checkedIcon={
                              <img src="/assets/img/icons/checked.svg" alt="" />
                            }
                            icon={
                              <img
                                src="/assets/img/icons/unchecked.svg"
                                alt=""
                              />
                            }
                          />
                        }
                        sx={{
                          px: "15px",
                          py: "10px",
                          display: "flex",
                          gap: "8px",
                          span: {
                            color: "#323232",
                            fontSize: "14px",
                            fontWeight: 500,
                          },
                        }}
                      />
                    </Stack>
                  ))}
                </Box>
              )}
              {savedAddress.length === 0 && (
                <Box
                  sx={{
                    mx: "4%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "100%",
                    my: "8%",
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/img/icons/address_empty.svg"
                    alt=""
                    sx={{
                      width: {
                        md: "314px",
                        lg: "314px",
                        xl: "314px",
                        sm: "200px",
                        xs: "200px",
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      color: "#323232",
                      fontWeight: 700,
                      fontSize: "26px",
                      lineHeight: "31px",
                      mt: "20px",
                      mb: "10px",
                      textAlign: "center",
                    }}
                  >
                    No Saved Address Yet!
                  </Typography>
                  <Typography
                    sx={{
                      color: "#A2A2A2",
                      fontWeight: 500,
                      fontSize: "16px",
                      lineHeight: "24px",
                      mb: "15px",
                      textAlign: "center",
                    }}
                  >
                    It seems you haven't saved an address yet. Please add an
                    address to complete your booking.
                  </Typography>
                </Box>
              )}
              <Box
                sx={{
                  display: {
                    md: "none",
                    lg: "none",
                    xl: "none",
                    sm: "flex",
                    xs: "flex",
                  },
                }}
              >
                <Button
                  sx={{
                    height: "56px",
                    borderRadius: "10px",
                    mt: {
                      md: "200px",
                      lg: "200px",
                      xl: "200px",
                      sm: "10px",
                      xs: "10px",
                    },
                  }}
                  variant="contained"
                  fullWidth
                  onClick={() => setAddAddressForm(true)}
                >
                  Add New Address
                </Button>
              </Box>
            </Box>
          </Box>
        </Grid>
        <Grid
          item
          md={8}
          lg={8}
          xl={8}
          sm={12}
          xs={12}
          sx={{
            display: {
              sm: "none",
              xs: "none",
              md: "flex",
              lg: "flex",
              xl: "flex",
            },
          }}
        >
          <AddressForm
            createAddress={createAddress}
            editData={editAddressData}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SavedAddress;
